var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import './types';
var baseProps = {
    small: {
        width: '16',
        height: '16',
        viewBox: '0 0 16 16',
    },
    large: {
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
    },
};
export var ChevronDown = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'small' : _b, props = __rest(_a, ["size"]);
    var mergeProps = __assign(__assign({ fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, baseProps[size]), props);
    var d = useMemo(function () {
        if (size === 'small') {
            return 'M12.773 4.82321C12.9682 4.62795 13.2848 4.62796 13.4801 4.82322L13.8336 5.17678C14.0289 5.37204 14.0289 5.68862 13.8336 5.88388L8.35354 11.364C8.15828 11.5592 7.8417 11.5592 7.64644 11.364L2.16636 5.88388C1.9711 5.68862 1.9711 5.37204 2.16636 5.17678L2.51992 4.82322C2.71518 4.62796 3.03176 4.62795 3.22702 4.82321L7.99999 9.596L12.773 4.82321Z';
        }
        return 'M4.88394 8.76256C4.68868 8.5673 4.3721 8.5673 4.17683 8.76256L3.82328 9.11612C3.62802 9.31138 3.62802 9.62796 3.82328 9.82322L11.6465 17.6464C11.8418 17.8417 12.1583 17.8417 12.3536 17.6464L20.1768 9.82322C20.3721 9.62796 20.3721 9.31138 20.1768 9.11612L19.8233 8.76256C19.628 8.5673 19.3114 8.5673 19.1162 8.76256L12.0001 15.8787L4.88394 8.76256Z';
    }, [size]);
    return (React.createElement("svg", __assign({}, mergeProps),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor", d: d })));
};
export default ChevronDown;
//# sourceMappingURL=ChevronDown.js.map